import React from "react";

import Banner from "./Banner";
import Footer from "./Footer";
import TituloPlaca from "./TituloPlaca";
import capa from "../images/capa-2026.webp";

const LINK_RELATORIO = "https://docsend.com/view/s3qcj7ww6eatsu5z";
const LINK_PRIMEIRA = "https://docsend.com/view/h4e3mbqndjcv8pqq";

// Todos os números saem da 2ª Pesquisa Nacional das Criptomoedas (agosto/2026).
const VARIACOES = [
  { numero: "66,4%", frase: "já conhecem criptomoedas" },
  { numero: "17,2%", frase: "já investiram em criptomoedas" },
  { numero: "4,0%", frase: "já usaram uma carteira própria" },
];

const Relatorio = () => {
  return (
    <div className="pagina">
      <Banner />

      <main className="cena">
        <div className="cena-conteudo">
          <div className="texto">
            <p className="chamada">Agosto de 2026</p>

            <TituloPlaca variacoes={VARIACOES} />
          </div>

          <div className="palco">
            <a
              className="livro"
              href={LINK_RELATORIO}
              target="_blank"
              rel="noreferrer"
              aria-label="Abrir o relatório da Segunda Pesquisa Nacional das Criptomoedas"
            >
              <span className="livro-corpo">
                <img
                  className="livro-capa"
                  src={capa}
                  alt="Capa do relatório da Segunda Pesquisa Nacional das Criptomoedas, agosto de 2026"
                  width={1000}
                  height={1294}
                  decoding="async"
                />
                <span className="livro-luz" aria-hidden="true" />
                <span className="livro-lombada" aria-hidden="true" />
                <span className="livro-folhas" aria-hidden="true" />
              </span>
              <span className="livro-sombra" aria-hidden="true" />
            </a>
          </div>

          <div className="acao">
            <a className="botao" href={LINK_RELATORIO} target="_blank" rel="noreferrer">
              Veja o relatório <span aria-hidden="true">→</span>
            </a>

            <a
              className="botao botao-fraco"
              href={LINK_PRIMEIRA}
              target="_blank"
              rel="noreferrer"
            >
              Veja a 1ª edição <span aria-hidden="true">→</span>
            </a>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Relatorio;
